export default __webpack_public_path__ + "static/media/add-knife-block.8bb33b9a.svg";